// extracted by mini-css-extract-plugin
export var container = "_4l-0";
export var fallback = "_4l-5";
export var fallbackIcon = "_4l-6";
export var hidden = "_4l-2";
export var image = "_4l-3";
export var loaded = "_4l-4";
export var placeholder = "_4l-1";